/**
 * @module app.um
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { INotesConfig } from 'app/core/models/essette-interfaces';

@autoinject()
export class ManageAuthNotesPage {

    ////****************** Fields and Properties ************************************////
    protected displayTabs: Record<string, boolean> = {};

    protected notesConfig: INotesConfig = {
        serviceRootUrl: 'um/auths',
        targetType: 'UM.Auth',
        moduleCode: 'UM'
    };

    protected captionPrefix: string | null = "Authorization";

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly logger: AppLogger) {
        this.logger.source = this;
    }

    ////****************** Element References ***************************************////

    ////****************** Functions ************************************************////
    protected displayTabContents(tabId: string): void {
        this.displayTabs[tabId] = true;
    }
}
